
import { defineComponent } from 'vue'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'
import registryDatatableWarningDialogDescriptor from './RegistryDatatableWarningDialogDescriptor.json'

export default defineComponent({
    name: 'registry-datatable-warning-dialog',
    components: { Checkbox, Dialog },
    emits: ['close'],
    props: {
        visible: { type: Boolean },
        columns: { type: Array, required: true }
    },
    data() {
        return {
            registryDatatableWarningDialogDescriptor,
            stopWarnings: false
        }
    },
    computed: {
        columnFileds(): string {
            let fields = ''
            for (let i = 0; i < this.columns.length; i++) {
                fields += (this.columns[i] as any).title + (i === this.columns.length - 1 ? ' ' : ', ')
            }

            return fields
        }
    },
    created() {},
    methods: {}
})
